module.exports = __webpack_public_path__ + "static/media/13n.b3004cf8.png";